// @flow
import axios from "axios";
import tvgConf from "@tvg/conf";
import uam from "@tvg/api/uam";

import type { OnboardingRoute } from "@tvg/types/OnBoarding";

/**
 * Gets the list of routes with available tutorials
 * @returns {Promise<Route[] | never>}
 */
export const getOnboardingRoutes = (): Promise<OnboardingRoute[]> => {
  const conf = tvgConf();
  const url = `${conf.config().service.capi}/route`;

  const requestOptions = {
    method: "GET",
    url,
    headers: {
      "content-type": "application/json",
      "x-tvg-context": conf.context(),
      "x-requested-with": "XMLHttpRequest"
    },
    withCredentials: true
  };

  return axios(requestOptions)
    .then(({ data }) => data)
    .then((routes) =>
      routes.filter((r) => !!r.tutorial && r.tutorial.isActive)
    );
};

export const setOnboardingAsSeen = (
  accountNumber: number,
  seenOnboardings: string[]
) => {
  const onboardingsSeen = seenOnboardings.join(",");
  return uam
    .setUserPref(accountNumber, "onboardingsSeen", onboardingsSeen)
    .then(() => onboardingsSeen);
};

export default {
  getOnboardingRoutes,
  setOnboardingAsSeen
};
